import { render, staticRenderFns } from "./setup-profile.vue?vue&type=template&id=0b0d890c&"
import script from "./setup-profile.vue?vue&type=script&lang=js&"
export * from "./setup-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports